var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#C7F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.95 30C26.8667 30 24.8083 29.546 22.775 28.638C20.7417 27.73 18.8917 26.4423 17.225 24.775C15.5583 23.1077 14.271 21.2577 13.363 19.225C12.455 17.1923 12.0007 15.134 12 13.05C12 12.75 12.1 12.5 12.3 12.3C12.5 12.1 12.75 12 13.05 12H17.1C17.3333 12 17.5417 12.0793 17.725 12.238C17.9083 12.3967 18.0167 12.584 18.05 12.8L18.7 16.3C18.7333 16.5667 18.725 16.7917 18.675 16.975C18.625 17.1583 18.5333 17.3167 18.4 17.45L15.975 19.9C16.3083 20.5167 16.704 21.1123 17.162 21.687C17.62 22.2617 18.1243 22.816 18.675 23.35C19.1917 23.8667 19.7333 24.346 20.3 24.788C20.8667 25.23 21.4667 25.634 22.1 26L24.45 23.65C24.6 23.5 24.796 23.3877 25.038 23.313C25.28 23.2383 25.5173 23.2173 25.75 23.25L29.2 23.95C29.4333 24.0167 29.625 24.1377 29.775 24.313C29.925 24.4883 30 24.684 30 24.9V28.95C30 29.25 29.9 29.5 29.7 29.7C29.5 29.9 29.25 30 28.95 30ZM15.025 18L16.675 16.35L16.25 14H14.025C14.1083 14.6833 14.225 15.3583 14.375 16.025C14.525 16.6917 14.7417 17.35 15.025 18ZM23.975 26.95C24.625 27.2333 25.2877 27.4583 25.963 27.625C26.6383 27.7917 27.3173 27.9 28 27.95V25.75L25.65 25.275L23.975 26.95Z",
    fill: "#062A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.6ee99549e260809a5aaf9fc8af2cb192.svg";
export { ForwardRef as ReactComponent };